
import React, { ReactElement } from "react";
import * as _ from "lodash";
import { DateTime } from "luxon";
import { FormattedMessage } from "react-intl";
import { List, ListItem } from "@mui/material";
import { BackButton } from "tp/views/common-forms/components";
import { StampContext } from "tp/shared/timeclock/messages";
import SelectCompany from "./SelectCompany";
import { MissingTask } from "./";
import { CostDivisionListProps, StampDirection, StampCostDivision } from "tp/shared/timeclock/models";
import { Black } from "tp/shared/common-design/colors";

const Title = ({ customTitle, lastStamp, task }: Partial<CostDivisionListProps>): ReactElement => {
    const currentTime = DateTime.now();
    const stampedIn = lastStamp && StampDirection[lastStamp.direction] === StampDirection.In;
    const stampedOut = lastStamp && StampDirection[lastStamp.direction] === StampDirection.Out;
    const stampedInToday = stampedIn && lastStamp.dateTime.hasSame(currentTime, "day");

    if (customTitle) {
        return <FormattedMessage {...customTitle} />;
    } else if ((!stampedInToday && !task) || (task && !task.date.hasSame(currentTime, "day") && stampedOut)) {
        return <><span style={{ padding: "10px 10px 0px 10px" }}><MissingTask stampCostDivisions={null} /></span><br /><span style={{ padding: "0px 10px 10px 10px" }}><FormattedMessage {...StampContext.ChooseCostDivision} /></span></>;
    } else {
        return <FormattedMessage {...StampContext.ChooseCostDivision} />;
    }
};

function CostDivisionGroup(props: {
    costDivisionGroup: StampCostDivision[];
    groupKey: string;
    onSelect: (arg0: number) => void;
}): ReactElement {
    const { costDivisionGroup, groupKey, onSelect } = props;
    const headerStyle = {
        overflow: "hidden",
        lineHeight: "42px",
        fontSize: "2.4em",
        color: Black
    };

    return (
        <>
            <h1 style={headerStyle}>{groupKey}</h1>
            {costDivisionGroup.map(cdg => {
                const { costDivisionName, costDivisionRef } = cdg;
                return (
                    <ListItem
                        key={costDivisionRef}
                        className="tc-list-entry"
                        onClick={() => onSelect(costDivisionRef)}
                    >
                        {costDivisionName}
                    </ListItem>
                );
            })}
        </>
    );
}

export function CostDivisionList(props: CostDivisionListProps): ReactElement {
    const {
        costDivisions,
        onBackClick,
        onSelect,
        ...titleProps } = props;
    const costDivGroups = _(costDivisions).groupBy("hotelAbbreviation");
    const showDivisions = costDivGroups.some((costDivs) => costDivs.length > 4);
    const costDivLists = costDivGroups
        .map((costDivisionGroup, groupKey) =>
            <div className="column" key={groupKey}>
                <List style={{ paddingBottom: "0px" }}>
                    <CostDivisionGroup
                        onSelect={onSelect}
                        {...{ costDivisionGroup, groupKey }}
                    />
                </List>
            </div>
        )
        .value();

    const noSelect = (
        <>
            <div className="stamp-messagebox">
                <Title {...titleProps} />
            </div>
            <div style={{ width: "75%" }}>{costDivLists}</div>
            <BackButton onClick={onBackClick} />
        </>
    );

    const askCompany = costDivLists.length > 3 || (showDivisions && costDivLists.length !== 1);

    return (
        <div className="stamp-list">
            {askCompany
                ?
                <SelectCompany
                    costDivisions={costDivisions}
                    onSelect={onSelect}
                    onBackClick={onBackClick}
                />
                :
                noSelect
            }
            <br />
        </div>
    );
}
